import MicrosoftIcon from "@/assets/icons/microsoft.svg";
import Button, { ButtonProps } from "@components/Button";

import styles from "./MicrosoftButton.module.css";

const MicrosoftButton = (props: ButtonProps) => {
  return (
    <Button
      block
      className={styles.root}
      icon={MicrosoftIcon}
      variant="secondary"
      {...props}
    ></Button>
  );
};

export default MicrosoftButton;
